import api from '@/api/activityTypeRole'
import { errorHandler } from '../exports/error_management'

const state = {
    item: null,
    items: [],
    pagination: null,
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
}
const actions = {
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    context.commit('set_item', data)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
}

const getters = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
